import React from "react";
import Svg, { Path, SvgProps, G } from "react-native-svg";

const Cross = (svgProps: SvgProps) => {
  return (
    <Svg viewBox="0 0 25 25" {...svgProps}>
      <G clipPath="url(#clip0_1102_4005)">
        <Path
          d="M18.7535 5.25052L5.25122 18.7528"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M18.7535 18.7528L5.25122 5.25052"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
    </Svg>
  );
};

export default Cross;
